module.exports = __webpack_public_path__ + "static/media/fennec-fox-3.e1c58e0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/fennec-fox-3.jpg
// module id = 246
// module chunks = 1